import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useAtom } from '../../lib';
import { navigationPinAtom } from '../../atoms';
import walletPopupOpenAtom from '../../atoms/wallet/walletPopupOpenAtom';
import { NostraStakingSunsetBanner, OracleUnavailableBanner } from '../shared';
import Navigation from '../Navigation';
import Toast from '../Toast';
import NavigationMobile from '../NavigationMobile';
import { LiquidationRiskBanner } from '../Products/LendAndBorrow';
import NoticePopup from './NoticePopup';
import MobileFooter from './MobileFooter';

import './Root.scss';

const Root = () => {
  const [navigationPin] = useAtom(navigationPinAtom);
  const [walletSidebarOpen] = useAtom(walletPopupOpenAtom);

  return (
    <>
      <div className="nostra__root__emergencyNotice" role="alert">
        <strong>Nostra Money Market is temporarily paused.</strong>{' '}
        We are investigating an issue, so lending and borrowing actions are currently unavailable.
      </div>
      {/* Banners use network atoms — don't block shell rendering */}
      <Suspense fallback={null}>
        <LiquidationRiskBanner />
      </Suspense>
      <Suspense fallback={null}>
        <OracleUnavailableBanner />
      </Suspense>
      <NostraStakingSunsetBanner />
      <NoticePopup />
      {/* Navigation components suspend on latestBlockAtom (RPC call).
          Wrap in Suspense so the page shell + route content render immediately. */}
      <Suspense>
        <Navigation />
      </Suspense>
      <Suspense>
        <NavigationMobile />
      </Suspense>
      <div
        className="nostra__root__productOutlet"
        data-navigation-pinned={navigationPin}
        data-wallet-sidebar-open={walletSidebarOpen}
      >
        <Outlet />
      </div>
      <Suspense>
        <MobileFooter />
      </Suspense>
      <Toast />
    </>
  );
};
export default Root;
